export default __webpack_public_path__ + "static/media/icon-back-white.b55fea68.svg";